var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "db relative center w-100", attrs: { id: "signup-modal" } },
    [
      _c(
        "div",
        { staticClass: "tc js-signup-container-modal center mw20rem-xs" },
        [
          _c(
            "div",
            { staticClass: "flex flex-row items-center justify-around" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.submission.userEmail,
                    expression: "submission.userEmail"
                  }
                ],
                staticClass:
                  "dib h38px w-70 mv2 transparent-bg b--white-input is-white is-bebas br0 f5 fb100 tc css-text-input js-signup-input",
                attrs: {
                  type: "email",
                  placeholder: "email@email.com",
                  required: ""
                },
                domProps: { value: _vm.submission.userEmail },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.submission, "userEmail", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "flex w-30 flex-row items-center justify-center center h38px mv2 btn-generic pointer js-signup-submit",
                  attrs: { title: "Email Signup Submit Button" },
                  on: {
                    click: function($event) {
                      return _vm.signupSubmit()
                    }
                  }
                },
                [
                  _c("span", { staticClass: "text f5 ttu is-bebas is-white" }, [
                    _vm._v("\n          signup\n        ")
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "relative tc" }, [
            _c("div", { staticClass: "db relative tc w-100 h-auto pv3" }, [
              _vm.successMessageIsVisible
                ? _c(
                    "span",
                    {
                      staticClass:
                        "db absolute left-0 right-0 center tc is-white"
                    },
                    [_vm._v("\n          Thanks for signing up!\n        ")]
                  )
                : _vm.errorMessageIsVisible
                ? _c(
                    "span",
                    { staticClass: "db absolute left-0 right-0 center is-red" },
                    [_vm._v("\n          Please enter a valid email\n        ")]
                  )
                : _c(
                    "span",
                    { staticClass: "db absolute left-0 right-0 center o-0" },
                    [_vm._v("\n          None\n        ")]
                  )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }